import { sendSoapRequest, createSoapEnvelope } from './soapClient.js'; // Import the SOAP request function

// Function to create a prompt using the SOAP API
const createPrompt = async (promptData,username, password, setProgress) => {
  // Construct the XML body for the prompt creation
  const body = `
    <ser:addPromptTTS>
      <prompt>
        <name>${promptData.name}</name>
        <description>${promptData.description}</description>
        <type>TTSGenerated</type>
        <languages>En_US</languages>
      </prompt>
      <ttsInfo>
        <language>en-US</language>
        <text>${promptData.verbiage}</text>
      </ttsInfo>
    </ser:addPromptTTS>
  `;

  // Wrap the body in a SOAP envelope
  const soapBody = createSoapEnvelope(body);

  try {
    // Send the SOAP request
    console.log('Prompt request body:', soapBody);
    const result = await sendSoapRequest('addPromptTTS', soapBody, username, password);
    console.log(`Prompt ${promptData.name} created successfully:`, result);
    setProgress(prev => [...prev, `Prompt created successfully: ${promptData.name}`]); // Update progress here
    return result; // Return the result from the SOAP response
  } catch (error) {
    console.error(`Error creating prompt ${promptData.name}:`, error);
    setProgress(prev => [...prev, `Error creating Prompt ${promptData.name}: ${error.message}`]);
    throw error; // Re-throw the error for further handling if needed
  }
};

export default createPrompt;
